'use client';

// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-react/build/generate-icons

import { IconListTree, iconListTreeTag } from '@ni/nimble-components/dist/esm/icons/list-tree';
import { wrap } from '../../utilities/react-wrapper';

export type { IconListTree };
export { iconListTreeTag };
export const NimbleIconListTree = wrap(IconListTree);